<template>
  <div class="coupon-create-page">
    <a-card :bordered="false">
      <template slot="title">
        <page-back-title title="新建优惠券" />
      </template>
      <coupon-form ref="couponForm" v-model="form">
        <template v-slot:footer>
          <a-button @click="handleBack">取消</a-button>
          <a-button type="primary" :loading="submitting" @click="handleSubmit">提交</a-button>
        </template>
      </coupon-form>
    </a-card>
  </div>
</template>

<script>
import CouponForm, { createDefaultCouponForm } from './components/CouponForm.vue'
import PageBackTitle from './components/PageBackTitle.vue'

export default {
  name: 'CouponCreate',
  components: {
    CouponForm,
    PageBackTitle
  },
  data () {
    return {
      submitting: false,
      form: createDefaultCouponForm()
    }
  },
  methods: {
    handleBack () {
      this.$router.back()
    },
    handleSubmit () {
      if (!this.$refs.couponForm.validate()) return
      this.submitting = true
      this.getHttpServices()
        .getNewServeService()
        .post('/coupon/create', this.$refs.couponForm.buildCreateParams())
        .then(() => {
          this.$message.success('新建成功')
          this.$router.push({ name: 'CouponList' })
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '新建失败，请重试')
        })
        .finally(() => {
          this.submitting = false
        })
    }
  }
}
</script>
